/* FeaturedSection.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _9 = "._18u0idpf{margin-left:0}";
const _8 = "._otyr68cl{margin-bottom:90pt}";
const _7 = "._2hwxidpf{margin-right:0}";
const _6 = "._19pk68cl{margin-top:90pt}";
const _5 = "@media (min-width:64rem){._1rqt16hb{grid-template-columns:repeat(3,1fr)}._pdlmhiv4{gap:var(--ds-space-400)}}";
const _4 = "._1e0c11p5{display:grid}";
const _3 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
import { media } from '@atlaskit/primitives/responsive';
import { BodyLarge, H3 } from '@atlassian/mpac-primitives';
import React from 'react';
import { collections } from './constants';
import { FeaturedCard } from './FeaturedCard';
const _2 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _ = "._19pk1b66{margin-top:var(--ds-space-050,4px)}";
const Description = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pk1b66 _syaz1k3w", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
const SectionHeader = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_otyrxy5q", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SectionHeader.displayName = 'SectionHeader';
}
const CardsWrapper = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_4, _5]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c11p5 _1rqt16hb _pdlmhiv4", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  CardsWrapper.displayName = 'CardsWrapper';
}
const Section = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_6, _7, _8, _9]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pk68cl _2hwxidpf _otyr68cl _18u0idpf", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Section.displayName = 'Section';
}
export const FeaturedSection = () => {
  return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement(H3, null, "Crafted for Success: Our top collections"), /*#__PURE__*/React.createElement(Description, null, "Unlock success with our handpicked collections of top-tier apps.")), /*#__PURE__*/React.createElement(CardsWrapper, null, collections.map(collection => {
    const {
      id,
      title,
      description,
      image,
      backgroundColor
    } = collection;
    return /*#__PURE__*/React.createElement(FeaturedCard, {
      key: id,
      title: title,
      description: description,
      image: image,
      backgroundColor: backgroundColor
    });
  })));
};